import { EditAction } from '../shared/enum/EditAction';
import { JournalistCategoryModel } from './JournalistCategoryModel';

export interface JournalistModel {
    id: number,
    name: string,
    userId: number | null,
    codeMetric: number | null,
    categoryId: number,
    category: JournalistCategoryModel | null,
    startOfPeriod: Date | null,
    endOfPeriod: Date | null,
    editAction: EditAction
}

export const journalistModelInitial: JournalistModel = {
    id: 0,
    name: '',
    userId: null,
    codeMetric: null,
    categoryId: 0,
    category: null,
    startOfPeriod: null,
    endOfPeriod: null,
    editAction: EditAction.NONE
};